'use client';

import { c as _c } from "react/compiler-runtime";
import { useGetUser } from '@morfi/backend-sdk-v2/client';
import { levelForDays } from '@/lib/streaks';
import { TierEmblem } from './tier-emblem';
interface WalletStreakChipProps {
  userId: string;
  walletPubkeys?: readonly string[];
}

/** Compact tier-emblem + day count for the wallet dropdown. Shown at 0 too. */
export function WalletStreakChip(t0) {
  const $ = _c(15);
  const {
    userId,
    walletPubkeys
  } = t0;
  let t1;
  if ($[0] !== walletPubkeys) {
    t1 = walletPubkeys ?? [];
    $[0] = walletPubkeys;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = ["currentStreak", "streakLastLocalDate"];
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t1 || $[4] !== userId) {
    t3 = {
      identifier: userId,
      walletPubkeys: t1,
      fields: t2
    };
    $[3] = t1;
    $[4] = userId;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const {
    data
  } = useGetUser(t3);
  const currentStreak = data?.currentStreak ?? 0;
  let t4;
  if ($[6] !== currentStreak) {
    t4 = levelForDays(currentStreak);
    $[6] = currentStreak;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const level = t4;
  let t5;
  if ($[8] !== level) {
    t5 = <TierEmblem level={level} size={16} />;
    $[8] = level;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== currentStreak) {
    t6 = <span className="font-mono text-caption font-medium leading-none">{currentStreak}</span>;
    $[10] = currentStreak;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t5 || $[13] !== t6) {
    t7 = <span className="inline-flex items-center gap-1 rounded-pill bg-background-tertiary px-2 py-1">{t5}{t6}</span>;
    $[12] = t5;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  return t7;
}